import React from 'react';

import AuthenticationService from '../../backend/AuthenticationService';
import { userService } from '../UserService';
import { translate } from "react-i18next";
import {Link, Redirect} from 'react-router-dom';
import {  Row, Col, Card, Alert } from 'react-bootstrap';
import '../App.css';
import '../event/EventAddTabs.css';
import {GREY_LIGHT} from '../../backend/Colors';


class LoginPage extends React.Component {
    constructor(props) {
        super(props);

        userService.logout();

        this.state = {
            username: '',
            user:this.props.user,
            password: '',
            submitted: false,
            loading: false,
            error: '',
            hasLoginFailed: false,
            showSuccessMessage: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });
        const { username, password } = this.state;

        // stop here if form is invalid
        if (!(username && password)) {
            return;
        }

        this.setState({ loading: true });
        
        AuthenticationService
        .executeJwtAuthenticationService(username, password)
        .then((response) => {
            AuthenticationService.registerSuccessfulLoginForJwt(username, response.data.token, response.data.user);
            let oldState = this.state;
           this.setState(
                {...oldState,
                    hasLoginFailed: false,
                    loading: false,
                    user: username
                }
            );
            //this.props.updateModel("user", username);
            //window.location = '/';
            //return <Redirect push  to="/eventAdd" />
        }).catch(() => {
            let oldState = this.state;
            this.setState(
                {...oldState,
                    showSuccessMessage: false,
                    hasLoginFailed: true,
                    loading: false,
                    error:'loginFailed'
                }
            );
        });
    }

    inputValid(){
        return true;//this.state.username && this.state.password;
    }

    render() {
        const { t } = this.props;
        const { username, password, submitted, loading, error } = this.state;
        let page = this.props.forward ? this.props.forward :"home"
        let path = this.props.forward + (this.props.idx ? ("/"+this.props.idx) :"" )
        console.log("--this.props.key :"+this.props.idx);
        return (
            <div>
                { AuthenticationService.isUserLoggedIn()?
                   <Redirect to={'/'+path  } />
                :
               <Card className="text-left mt-5" style={{"background":GREY_LIGHT}}>
                  <Card.Header className="text-primary"><h4>{t("loginTitle")}</h4></Card.Header>
                    <Card.Body style={{"background":GREY_LIGHT}}>
                    <div>
                                {error ?
                                <Alert variant="danger">{t(error)}</Alert>
                                :
                                ''
                                }
                            </div>
                        <form name="form" onSubmit={this.handleSubmit}>
                            <div className={'greyBg form-group' + (submitted && !username ? ' has-error' : '')}>
                                <input type="text" className="form-control" name="username" value={username} onChange={this.handleChange} placeholder={t("E-Mail")}
                                 maxLength={250} />
                                {submitted && !username &&
                                    <div className="help-block">{t("UsernameIsRequired")}</div>
                                }
                            </div>
                            <div className={'form-group' + (submitted && !password ? ' has-error' : '')}>
                                <input type="password" className="form-control" name="password" value={password} onChange={this.handleChange} placeholder={t("Passwort")}
                                 maxLength={250} />
                                {submitted && !password &&
                                    <div className="help-block">{t("UsernameIsRequired")}{t("passwordIsRequired")}</div>
                                }
                            </div>
                            <div className="form-group">
                            <button className="btn btn-primary float-right" disabled={loading || !this.inputValid()}>{t("login")}</button>
                            {loading &&
                                    <img alt="loading..." src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                }
                            
                            </div>
                            
                            
                        </form>
                </Card.Body>
                <Card.Footer >
                    <Row>
                        <Col>
                            <Link to="/passwordForgotten" className={'form-group' }>{t("passwordForgotten")}</Link>
                        </Col>
                        <Col>
                        <Link to="/registration" className={'form-group float-right ' }>
                      <i className="text-primary fa fa-user-plus  mr-2" ></i>
                      {t("createAccount")}</Link>
                        </Col>
                    </Row>
                    
                     
                </Card.Footer>
                </Card>
                }
            </div>
        );
    }
}

export default translate("translations")(LoginPage);
